export default "__VITE_ASSET__BBXJOTIE__"